import React, { useCallback, useMemo } from "react";
import classes from "./tileList.module.css";

const TileList = (props) => {
  const { getItemKey, selectedValue = {}, items, onSelectionChange } = props;

  const handleClick = useCallback(
    (value) => {
      if (value) {
        onSelectionChange(value);
      } else {
        return;
      }
    },
    [onSelectionChange]
  );

  const tilestemp = useMemo(
    () =>
      items.map((item) => {
        const isSelected = item.label === selectedValue.label;

        return (
          <option key={getItemKey(item)} value={item.value_index}>
            {item.label}
          </option>
        );
      }),
    [getItemKey, selectedValue.label, items, onSelectionChange]
  );

  return (
    <div className={classes.root}>
      <select
        className={`${classes.selectcustom} form-select `}
        onChange={(e) => handleClick(parseInt(e.target.value))}
      >
        <option value="">Select</option>
        {tilestemp}
      </select>
    </div>
  );
};

export default TileList;
